import { computed } from "vue";
import { hasCookie } from "../../../helpers/cookie";
import { createSingularAsyncApi } from "../../partials/async";

const ACC_AUTH_COOKIE_NAME = 'acc_user_login'

export default function createUserData(){
    const api = createSingularAsyncApi(
        'bt_get_user_profile',
        'GET',
        {
            responseKey: 'user',
        }
    )

    /**
     * If the current user has an individual member(ship)
     */
    const is_individual_member = computed(
        () => api.details.value?.member?.is_individual_member
    )

    /**
     * If the current user has an organisation member(ship)
     */
    const is_organisation_member = computed(
        () => api.details.value?.member?.is_organisation_member
    )

    //If we don't have the cookie assume we're unauthenticated so don't bother making the user request
    //If we do have the cookie we should attempt to find the user
    hasCookie(ACC_AUTH_COOKIE_NAME)
        .then(has => {
            if(!has){
                api.retrieved.value = true
            } else {
                api.api.execute()
            }
        })

    return {
        ...api,

        /**
         * If the current user is logged in
         * 
         * Assume if we have an id we're authenticated
         */
        is_authenticated: computed(
            () => api.details.value?.id !== undefined
        ),

        /**
         * If the current user is a member
         */
        is_member: computed(
            () => is_individual_member.value
                || is_organisation_member.value
        ),

        is_individual_member   : is_individual_member,
        is_organisation_member : is_organisation_member
    }
}